import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import customerApi from "../lib/customerApi";

const CustomerAuthContext = createContext(null);
const TOKEN_KEY = "svrm_customer_token";

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setBooted(true);
      return;
    }
    customerApi
      .get("/customers/me")
      .then((r) => setCustomer(r.data))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setCustomer(null);
      })
      .finally(() => setBooted(true));
  }, []);

  const login = useCallback(async (login_id, password) => {
    const { data } = await customerApi.post("/customers/login", { login_id, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setCustomer(data.customer);
    return data.customer;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setCustomer(null);
  }, []);

  const getToken = () => localStorage.getItem(TOKEN_KEY);

  const value = useMemo(() => ({ customer, login, logout, booted, getToken }), [customer, login, logout, booted]);

  return <CustomerAuthContext.Provider value={value}>{children}</CustomerAuthContext.Provider>;
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
